import * as React from 'react';

export interface ErrorMessage {
  message: string;
}

export interface Return {
  error: ErrorMessage | null;
  setError: React.Dispatch<React.SetStateAction<ErrorMessage | null>>;
}

export const ErrorMessageContext = React.createContext<Return>({} as Return);

const Provider: React.FC = ({ children }) => {
  const [error, setError] = React.useState<ErrorMessage | null>(null);
  return (
    <ErrorMessageContext.Provider
      value={{
        error,
        setError,
      }}
    >
      {children}
    </ErrorMessageContext.Provider>
  );
};

export default Provider;
